export enum TimeRegistrationEntity {
	Task = 'Task',
	Project = 'Project',
	IdleTime = 'IdleTime',
}

export type TimeRegistrationEntityId = {
	entity: TimeRegistrationEntity;
	id: number;
};

export type PossibleEntityId = {
	taskId: string | null | undefined;
	projectId: string | null | undefined;
	idleTimeId: string | null | undefined;
};

export type BackendEntityId = {
	taskId: number | null;
	projectId: number | null;
	idleTimeId: number | null;
};
